var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heading mb-4 d-flex flex-column flex-lg-row flex-wrap justify-content-between align-items-center"},[(_vm.title)?[_c('h2',{staticClass:"my-2"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]:_vm._e(),_c('div',{staticClass:"heading__buttons"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }